
export const OrderListPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">수주 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select">
                                <option>수주</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">수주일자</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">수주 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>

                        <button className="btn btn-outline-success w-80px px-0">출하요청</button>
                        <button className="btn btn-dark w-80px">추가</button>
                        <button className="btn btn-outline-dark"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ width: "4.4%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th>수주일자</th>
                                <th>담당자</th>
                                <th>고객사</th>
                                <th>매출처</th>
                                <th>품목</th>
                                <th>규격</th>
                                <th>수량</th>
                                <th>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                <tr>
                                    <td style={{ width: "4.4%" }} className="text-center">
                                        <div className="checkbox_outer"><input
                                            className="form-check-input"
                                            type="checkbox"
                                        /></div>
                                    </td>
                                    <td className="text-center" style={{ width: "10.06%" }}>2024.01.10</td>
                                    <td className="text-center" style={{ width: "10.06%" }}>김민성</td>
                                    <td className="text-center" style={{ width: "11.94%" }}>(주)구구구</td>
                                    <td className="text-center" style={{ width: "11.94%" }}>(주)매출처매출</td>
                                    <td className="text-center" style={{ width: "20.1%" }}>CSP영구라이선스</td>
                                    <td className="text-center" style={{ width: "11.94%" }}></td>
                                    <td className="text-center" style={{ width: "7.54%" }}>1</td>
                                    <td className="text-center">수주</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}